import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  FeedLoadAction,
  FeedLoadNewerThreadsAction,
  FeedLoadOlderThreadsAction,
} from '../../domains/feedLoad/actions.types';
import type { PublishGroupMessageFulfilledAction } from '../../domains/publishers/actions.types';
import type { NormalizedThreadEntities } from '../../normalization/types';

import type { GroupFeedsLastMessage } from './types';

export type GroupFeedLastMessageAction =
  | FeedLoadAction
  | FeedLoadNewerThreadsAction
  | FeedLoadOlderThreadsAction
  | PublishGroupMessageFulfilledAction;

const initialState: GroupFeedsLastMessage = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const updateLastMessage = (state: GroupFeedsLastMessage, groupId: string, entities: NormalizedThreadEntities) => {
  const { messages } = entities;
  const newMessage = messages && Object.values(messages).length === 1 ? Object.values(messages)[0] : undefined;

  const { fulfilled } = state;
  const lastMessage = fulfilled.byId[groupId];

  if (lastMessage) {
    const newMessageDate = Date.now();
    const newMessageId = (newMessage && newMessage.id) || undefined;
    const newMessageThreadId = (newMessage && newMessage.threadId) || undefined;

    const newLastMessage = {
      ...lastMessage,
      lastMessageAt: newMessageDate,
      lastMessageId: newMessageId,
      lastThreadId: newMessageThreadId,
    };

    return {
      ...state,
      fulfilled: {
        ...fulfilled,
        byId: {
          ...fulfilled.byId,
          [groupId]: { ...lastMessage, ...newLastMessage },
        },
      },
    };
  }

  return state;
};

const reducer: Reducer<GroupFeedsLastMessage, GroupFeedLastMessageAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupFeedsLastMessage);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupFeedsLastMessage);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupFeedsLastMessage);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return updateLastMessage(state, action.payload.groupId, action.payload.entities);
    default:
      return state;
  }
};

export default reducer;
